export default "__VITE_ASSET__119ca776__"